import { SvgIcons } from "../../../SharedComponents/SvgIcons/SvgIcons";
import styles from "./style.module.css";

/**
 * Upload control for a single KYC document. Click-to-upload while empty; once
 * something is on file (a freshly-picked file, or an already-uploaded document
 * from a previous save) shows its name plus a Replace action.
 * @param {Object} props
 * @param {React.RefObject} props.inputRef - Ref for the hidden file input.
 * @param {File} [props.file] - A freshly picked file, if any.
 * @param {string} [props.existingUrl] - URL of a previously uploaded document, if any.
 * @param {string} [props.existingName] - Display name for the existing document.
 * @param {() => void} [props.onView] - Opens the existing document (fetches a fresh signed URL).
 * @param {(e: React.ChangeEvent) => void} props.onSelect - File input change handler.
 * @param {string} props.accept - File input accept attribute.
 * @param {string} props.hint - Hint text shown under "Click to upload".
 * @param {string} [props.error] - Validation error, if any.
 * @param {boolean} [props.disabled] - Disables the Replace/upload triggers while saving.
 */
export const FileUploadField = ({
  inputRef,
  file,
  existingUrl,
  existingName,
  onView,
  onSelect,
  accept,
  hint,
  error,
  disabled,
}) => {
  const hasSomethingOnFile = !!file || !!existingUrl;

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className={styles.hiddenInput}
        onChange={onSelect}
      />
      {!hasSomethingOnFile && (
        <button
          type="button"
          disabled={disabled}
          className={`${styles.uploadBox} ${error ? styles.inputError : ""}`}
          onClick={() => inputRef.current.click()}
        >
          <span className={styles.uploadIconWrapper}>
            <SvgIcons name="upload_icon" width="18" height="19" className={styles.uploadIcon} />
          </span>
          <span className={styles.uploadTextGroup}>
            <span className={styles.uploadLabel}>Click to upload</span>
            <span className={styles.uploadHint}>{hint}</span>
          </span>
        </button>
      )}
      {hasSomethingOnFile && (
        <div className={styles.uploadedFileRow}>
          {file && <span className={styles.uploadedFileName}>{file.name}</span>}
          {!file && (
            <button type="button" className={styles.uploadedFileName} onClick={onView}>
              {existingName}
            </button>
          )}
          <button
            type="button"
            disabled={disabled}
            className={styles.replaceBtn}
            onClick={() => inputRef.current.click()}
          >
            Replace
            <SvgIcons name="replace_icon" width="16" height="16" />
          </button>
        </div>
      )}
    </>
  );
};
